import React, { forwardRef } from "react";

import ExpandMore from "@mui/icons-material/ExpandMore";
import { SelectChangeEvent } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";

import MDTypography from "../md-typography";
import { CustomSelect, StyledIcon, StyledOptions } from "./custom-select.styles";
import { KeyValue } from "@/models";

export type CustomSelectProps = {
  value: string;
  menuItems: KeyValue[];
  onChange: (value: string) => void;
  label?: string;
  name?: string;
  disabled?: boolean;
  readOnly?: boolean;
  fullWidth?: boolean;
  isError?: boolean;
  isLoading?: boolean;
};

export const CustomSelectComponent = ({
  value,
  menuItems,
  onChange,
  disabled,
  readOnly,
  fullWidth,
  isError,
  label,
  name,
  isLoading = false,
}: CustomSelectProps) => {
  const handleOnChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };
  return (
    <>
      {!!label && (
        <MDTypography variant="body2" fontWeight="bold" marginBottom="1.5ch">
          {label}
        </MDTypography>
      )}
      <CustomSelect
        id={"select-" + name}
        value={value}
        disabled={disabled}
        readOnly={readOnly}
        fullWidth={fullWidth}
        error={isError}
        onChange={handleOnChange}
        IconComponent={forwardRef((props, ref) => (
          <StyledIcon {...props} ref={ref as React.Ref<HTMLSpanElement>}>
            <ExpandMore style={{ cursor: "pointer", color: "inherit" }} />
          </StyledIcon>
        ))}
        endAdornment={
          isLoading ? (
            <InputAdornment position="end" style={{ marginRight: "2.5em" }}>
              <CircularProgress size={20} color="primary" />
            </InputAdornment>
          ) : null
        }
      >
        {menuItems.map((item, index) => (
          <MenuItem key={index} value={item.key}>
            <StyledOptions variant="body2">{item.value}</StyledOptions>
          </MenuItem>
        ))}
      </CustomSelect>
    </>
  );
};
